import React from 'react';
import { T } from 'shared/helper/translate';
import AbstractImage from '../images/file-lines-duotone.svg';
import RubriqAbstractStatus from './RubriqAbstractStatus';
var RubriqNoAbstractMessage = function RubriqNoAbstractMessage(_ref) {
  var onSubmitAbstract = _ref.onSubmitAbstract;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center gap-4 pt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center",
    style: {
      maxWidth: '600px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: AbstractImage,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-4 mt-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "start your first abstract"
  })), /*#__PURE__*/React.createElement("span", {
    className: "mt-2 text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.no-abstract-documents"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn btn-primary mt-4 rounded-3",
    onClick: function onClick() {
      return onSubmitAbstract('generate_abstract_button');
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "generate abstract"
  }))), /*#__PURE__*/React.createElement(RubriqAbstractStatus, {
    isNoAbstractMessage: true
  }));
};
export default RubriqNoAbstractMessage;